import React from 'react';
import './index.scss';
import Lazyload from '@tencent/h5-base-image';
import { ERROR_PIC } from '@/entities/pic';

function CrashTips() {
  return (
    <div className="CrashTips">
      <Lazyload
        className="btn-bg img"
        src={ERROR_PIC}
        tag="div"
        showImmediately={true}
      >
      </Lazyload>
      <div className="txt">
        <p>页面开小差了～</p>
        <p>请退出重试～</p>
      </div>
    </div>
  );
}

export default CrashTips;
